export function getMvsVinDetails(offer) {
  const { currency, mmvsList, vinList, itemsList } = offer
  let _mmvsList = []
  let _vinList = []

  if (mmvsList) {
    _mmvsList = mmvsList.map(mvs => {
      return itemsList.map(item => {
        const { itemDescription, itemTypeDescription, offerType, priceValue, quantity, sectionId, status } = item
        return {
          currency,
          itemDescription,
          itemTypeDescription,
          offerType,
          priceValue,
          quantity,
          status,
          sectionId,
          mvs
        }
      })
    })
  }

  if (vinList) {
    _vinList = vinList.map(vin => {
      return itemsList.map(item => {
        const { itemDescription, itemTypeDescription, offerType, priceValue, quantity, sectionId, status } = item
        return {
          currency,
          itemDescription,
          itemTypeDescription,
          offerType,
          priceValue,
          quantity,
          status,
          sectionId,
          vin
        }
      })
    })
  }

  _mmvsList = _.flatten(_mmvsList).sort((row1, row2) => row1.mvs.localeCompare(row2.mvs))
  _vinList = _.flatten(_vinList).sort((row1, row2) => row1.vin.localeCompare(row2.vin))

  return {
    ...offer,
    mmvsList: _mmvsList,
    vinList: _vinList
  }
}
